import React, { useEffect, useState } from 'react';
import './YourAccountsPage.scss';
import { RadioButton } from 'primereact/radiobutton';
import { getUserAccounts } from '../../../shared/services/user/accounts/UserAccountsService';
import { UserAccountsResponse } from '../../../shared/models/user/accounts/UserAccountsResponse';
import Loader from '../../../shared/components/common/loader/Loader';
import RoleTag from '../../../shared/components/color-tag/RoleTag';
import { useAccount } from '../../../shared/contexts/account/AccountContexts';
import { Column } from 'primereact/column';
import { DataTable } from '../../../shared/components/common/data-table/DataTable';
import { t } from 'i18next';
import { changeActiveAccount } from '../../../shared/services/user/UserService';
import { format } from 'date-fns';
import useIsMobile from '../../../shared/hooks/global/UseIsMobile';
import { MOBILE_PAGINATOR_TEMPLATE } from '../../../shared/utils/mobile';

const YourAccountsPage: React.FC = () => {
  const isMobile = useIsMobile();
  const { accountResponse } = useAccount();
  const [userAccounts, setUserAccounts] = useState<UserAccountsResponse[] | null>(null);

  useEffect(() => {
    getUserAccounts().then((userAccounts) => setUserAccounts(userAccounts));
  }, []);

  const changeAccount = (id: number) => {
    changeActiveAccount(id).then(() => {
      window.location.reload();
    });
  };

  if (!userAccounts) {
    return <Loader />;
  }

  const actionTemplate = (userAccount: UserAccountsResponse) => {
    return (
      <RadioButton
        inputId="none"
        checked={userAccount.accountId === accountResponse?.accountId}
        name="options"
        value={userAccount.accountId}
        onChange={(ev) => changeAccount(ev.target.value)}
      />
    );
  };

  return (
    <div className="your-accounts-page">
      <div>
        <DataTable
          stripedRows
          paginator
          paginatorClassName="pagination"
          removableSort
          sortField="accountEmail"
          sortOrder={1}
          rows={50}
          rowsPerPageOptions={[10, 25, 50]}
          value={userAccounts}
          tableStyle={{ minWidth: '50rem' }}
          tableClassName="table"
          className="table-wrapper table-wrapper--stack your-accounts-table"
          responsiveLayout="stack"
          currentPageReportTemplate={t('rowsNumber') + ':'}
          paginatorTemplate={
            isMobile
              ? MOBILE_PAGINATOR_TEMPLATE
              : 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
          }
          pageLinkSize={isMobile ? 3 : 5}
        >
          <Column
            field="accountEmail"
            header={t('accountOwner')}
            headerClassName="table__header"
            bodyClassName="table__cell--stack-title"
            body={(userAccount) => (
              <div>
                {userAccount.accountEmail}{' '}
                {userAccount.userRole === 'OWNER' && (
                  <span className="default-text">(Main account)</span>
                )}
              </div>
            )}
            style={{ minWidth: '120px' }}
          />
          <Column
            field="userRole"
            header={t('userRole')}
            headerClassName="table__header"
            body={(userAccount: UserAccountsResponse) => <RoleTag role={userAccount.userRole} />}
            style={{ width: '120px' }}
          />
          <Column
            field="created"
            header={t('created')}
            body={(userAccount) => format(userAccount.created, 'yyyy-MM-dd / HH:mm')}
            headerClassName="table__header"
            style={{ width: '280px' }}
          />
          <Column
            header={t('active')}
            headerClassName="table__header table__header--center"
            bodyClassName="table__cell table__cell--center table__cell--stack-actions"
            style={{ width: '40px' }}
            body={actionTemplate}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default YourAccountsPage;
